"use client";

import { useState } from "react";
import StandaloneAuditForm from "@/app/_components/StandaloneAuditForm";

type StatefulStandaloneAuditFormProps = {
  className?: string;
};

export default function StatefulStandaloneAuditForm({
  className,
}: StatefulStandaloneAuditFormProps) {
  const [showApiKey, setShowApiKey] = useState(false);

  return (
    <div className="z-30 w-1/2 xl:w-fit">
      <StandaloneAuditForm
        showApiKey={showApiKey}
        setShowApiKey={setShowApiKey}
      />
    </div>
  );
}
